import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-machine-dropdown',
  templateUrl: './machine-dropdown.component.html',
  styleUrls: ['./../dropdown.component.scss']
})
export class MachineDropdownComponent {
  @Input() options: Array<any>;
  @Input() title: string;
  activeTitle: string;
  isDropDown: boolean;

  @Output() readonly selectedOption: EventEmitter<any> = new EventEmitter<any>();

  onToggle(): void {
    this.isDropDown = !this.isDropDown;
  }

  onSelectOption(option: any): void {
    this.activeTitle = option.name;
    this.selectedOption.emit(option);
  }

  trackByFunction(index: number): number {
    return index;
  }
}
